import _ from 'lodash'
import Vue from 'vue'

export function matchEntityTarget (targets :string[], entity: any) {
  if (targets == null) {
    return true // legacy default for no-targets means ALL entities
  }

  for (var i = 0; i < targets.length; i++) {
    var target = targets[i]
    if (target.indexOf('entity/') === 0) {
      var entityMatch = target.substring(7)
      if (entityMatch.indexOf('label:') === 0) {
        var labelMatch = entityMatch.substring(6)
        if (_.includes(entity.labels, labelMatch)) {
          return true
        }
      }
    }
  }

  return false
}

export function matchStreamTarget (targets :string[], stream: any) {
  if (targets == null) {
    return false
  }

  for (var i = 0; i < targets.length; i++) {
    var target = targets[i]
    if (target.indexOf('stream/') === 0) {
      var entityMatch = target.substring(7)

      if (entityMatch === '*') { // match all streams
        return true
      }

      if (entityMatch.indexOf('label:') === 0) {
        var labelMatch = entityMatch.substring(6)
        if (_.includes(stream.labels, labelMatch)) {
          return true
        }
      }
    }
  }

  return false
}

export function extensionFromContentType (contentType: string) :string {
  switch (contentType) {
    case 'application/pdf': return 'pdf'
    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': return 'xlsx'
    case 'application/vnd.openxmlformats-officedocument.odt': return 'odt'
  }
  return 'dat'
}

export function dayOfMonthSuffix (dayOfMonth: number): string {
  if (_.includes([1, 21, 31], dayOfMonth)) { return 'st' }
  if (_.includes([2, 22], dayOfMonth)) { return 'nd' }
  if (_.includes([3, 23], dayOfMonth)) { return 'rd' }
  return 'th'
}


export function nestedVueSet (obj: any, path: string, value: any) {
  var keys = path.split('.')
  var lastKey: string|undefined = keys.pop()
  if (typeof lastKey === 'undefined') {
    return
  }
  _.each(keys, (key) => {
    if (!Object.hasOwnProperty.call(obj, key)) {
      Vue.set(obj, key, {})
    }
    obj = obj[key]
  })

  Vue.set(obj, lastKey, value)
}

/**
 * creates a flat list of locations, with parent prefixed names and a asset count on each
 * @param locations nested location tree
 * @param assets list of feEntity objects
 * @param assetModes asset Modes to include in filtered Locations
 */
export function flattenLocationHierarchy (locations: any[], assets: any[], assetModes: any[] = ['Enabled']) {
  const assetCountMap = assets.reduce((countMap, asset) => {
    if (_.includes(assetModes, asset.mode)) {
      countMap[asset.entity.locationId] = (countMap[asset.entity.locationId] || 0) + 1
    }
    return countMap
  }, {})

  const result: any[] = []

  function traverse (location: any, parentName = '', parentLevel = -1) {
    const fullName = parentName ? `${parentName} > ${location.label}` : location.label

    // Initialize the count for the current location
    let totalAssetCount = assetCountMap[location.id] || 0

    // Check if the location has children
    if (location.children && location.children.length > 0) {
      for (const child of location.children) {
        // Recursively traverse the children and accumulate their counts
        totalAssetCount += traverse(child, fullName, parentLevel + 1).assetCount
      }
    }

    // Add current location to the result list
    const locationResult = {
      level: parentLevel + 1,
      id: location.id,
      fullName: fullName,
      name: location.label,
      assetCount: totalAssetCount
    }

    result.push(locationResult)

    return locationResult
  }

  // Start recursion from the root locations
  for (const location of locations) {
    traverse(location)
  }

  return _(result)
    .filter((l) => l.assetCount > 0)
    .sortBy((l) => l.fullName.toLowerCase().trim())
    .value()
}


/**
 *
 * @param locations all nested location object from 'app.locations'
 * @param selectedIds selected IDs at any level
 * @param targetId one ID to find
 * @param inMatchingHiearchy default false, nested carry variable.
 */
export function isLocationInHierarchy (locations: any[], selectedIds: string[], targetId: string, inMatchingHiearchy = false) : boolean {
  if (locations == null || locations.length === 0) return false

  for (let l = 0; l < locations.length; l++) {
    const location = locations[l]
    const thisIsSelected = selectedIds.includes(location.id)

    if ((thisIsSelected || inMatchingHiearchy) && location.id === targetId) {
      return true
    }

    if (isLocationInHierarchy(location.children, selectedIds, targetId, inMatchingHiearchy || thisIsSelected)) {
      return true
    }
  }
  return false
}
